import script from "./ForgotResetMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotResetMobile.vue?vue&type=script&setup=true&lang=js"

import "./ForgotResetMobile.vue?vue&type=style&index=0&id=110e0b74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110e0b74"]])

export default __exports__